import AgentsStatistics from "./AgentsStatistics/AgentsStatistics";
import HistoryStatistics from "./HistoryStatistics/HistoryStatistics";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowRightAlt, MdFilterList, MdKeyboardBackspace } from "react-icons/md";
import Button from "../../../Components/Button/Button";
import moment from "moment";
import { api } from "../../..";
import { useNavigate, useParams } from "react-router-dom";
import Pusher from "../../../Pusher";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";
import InputDateTime from "../../../Components/InputDateTime/InputDateTime";


const Statistics = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [dateFrom, setDateFrom] = useState(moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"));
	const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));
    const { id } = useParams();
    const [disable, setDisable] = useState(false);
    const [queueCdr, setQueueCdr] = useState<Array<any>>([]);
    const [users, setUsers] = useState<Array<any>>([]);
	// eslint-disable-next-line
    const [members, setMembers] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
		if(api.isLoggedIn()) {
			fetchData(id);

			if(api.accessToken) {
                const pusher = new Pusher(api.accessToken);

				pusher.pushOnMessageListener('QueueCdr', () => {
					fetchData(id);
				})
			}

		} else {
			navigate("/login");
		}
		// eslint-disable-next-line
	}, []);

	const fetchData = (id:any) => {
		if(id) {
			const user = api.getUser();
            // CDR
			api.calls.queue.cdr.browse(id)
			.then((r: any) => {
                setQueueCdr(r.data);
                setLoading(false);
            });
            // User
			api.calls.company.user.browse(user.pbx_company_id, true)
			.then((r: any) => {
                setUsers(r.data);
                setLoading(false);
            });
		} else {
			toast.error('Unable to get data.');
		}
	}

    const filterData = (event:any) => {
        event.preventDefault();
        setDisable(true);
        setLoading(true);

        if(id) {
            api.calls.queue.cdr.search(
                {
                    'queues[]': id,
                    datetime_from: dateFrom,
                    datetime_to: dateTo,
                    limit: 1000
                }
            )
            .then((r:any) => setTimeout(() => {
                setQueueCdr(r.data['cdr'])
                setDisable(false);
                setLoading(false);
            }, 2000))
        }
    }

    return <div className="statistics">
		<div className="filer-header-panel">

			<div className="callout">
				<div className="filter">
					<div className="statistics-header-bar">
						<form onSubmit={filterData}>
							<MdFilterList className="icon-list"/>
							<label className="label-from">
								<InputDateTime
									value={dateFrom}
									onChange={([event]:any) => setDateFrom(moment(event).format('YYYY-MM-DD HH:mm:ss'))}
									minDate="2018-01-01"
									maxDate={moment().format('YYYY-MM-DD')}
									name="dateFrom"
									disableMobile={true}
								/>
							</label>
							<MdArrowRightAlt className="icon-arrow"/>
							<label className="label-to">
								<InputDateTime
									value={dateTo}
									onChange={([event]:any) => setDateTo(moment(event).format('YYYY-MM-DD HH:mm:ss'))}
									minDate="2018-01-01"
									maxDate={moment().format('YYYY-MM-DD')}
									name="dateTo"
									disableMobile={true}
								/>
							</label>
							<div className="statistics-header-button-group">
								<label className="filter-btn">
									{
										disable ?
											<label className="filter-btn">
												<Button
													icon={
														<Oval
															height={18}
															width={18}
															color="#7e84f4"
															wrapperClass="oval-icon"
															visible={true}
															ariaLabel='oval-loading'
															secondaryColor="#444791"
															strokeWidth={3}
															strokeWidthSecondary={4}
														/>
													}
												/>
											</label>
										:
											<label className="filter-btn">
												<Button
													buttonName={t('Filter')}
													onClick={() => onclick}
												/>
											</label>
									}
								</label>
								<label>
									<Button
										onClick={(e: any) => {
											e.preventDefault();
											window.history.back();
										}}
										buttonName={'Back to queue'}
										icon={<MdKeyboardBackspace />}
										btnClass="back-to-queue-button"
									/>
								</label>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<section className="history-statistics-panel">
			<HistoryStatistics
				dateFrom={dateFrom}
				dateTo={dateTo}
				queueCdr={queueCdr}
				users={users}
				loading={loading}
			/>
		</section>
		<section className="agents-statistics-panel">
			<AgentsStatistics
				dateFrom={dateFrom}
				dateTo={dateTo}
				members={members}
				queueCdr={queueCdr}
				loading={loading}
			/>
		</section>
    </div>
}

export default Statistics;
